import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

import { CheckableInput } from './CheckableInput';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  label: ReactNode;
  subLabel?: string;
};

export const CheckBox = forwardRef<HTMLInputElement, Props>((props, ref) => {
  return <CheckableInput type="checkbox" ref={ref} {...props} />;
});

CheckBox.displayName = 'CheckBox';
